module.exports = __webpack_public_path__ + "img/Always-on Connectivity.66800e3f.svg";